<app-data-grid
  [viewId]="viewId"
  [title]="title"
  [icon]="icon"
  gridClassName="dimensions-grid"
  [columnDefs]="columnDefs"
  [fetchRows]="fetchRows"
  [refreshOnCompanyObjectsToggle]="true"
></app-data-grid>
